/* SmartPaw — FurVac sets & levering (testblok) */

(function(){
  'use strict';

  function money(c){ return '\u20ac' + (c/100).toFixed(2).replace('.', ','); }

  function destOf(v){
    v = (v || '').trim();
    if (v.charAt(0) === '/') return v;
    if (v.indexOf('http://') === 0 || v.indexOf('https://') === 0) return v;
    return '';
  }

  /* ---------------- levertijd teller ---------------- */
  function startTimer(box){
    if (box.dataset.timerReady) return;
    box.dataset.timerReady = '1';

    var cut   = (box.dataset.cutoff || '16:00').split(':');
    var ch    = parseInt(cut[0], 10) || 0;
    var cm    = parseInt(cut[1], 10) || 0;
    var skip  = box.dataset.skipWeekend === 'true';
    var extra = parseInt(box.dataset.extraDays || '0', 10);
    var lang  = box.dataset.locale || document.documentElement.lang || 'nl';
    var elT   = box.querySelector('[data-timer]');
    var elD   = box.querySelector('[data-day]');
    if (!elT || !elD) return;

    var nl = lang.toLowerCase().indexOf('nl') === 0;

    function isWeekend(d){ var w = d.getDay(); return w === 0 || w === 6; }
    function nextDay(d){ var x = new Date(d); x.setDate(x.getDate() + 1); return x; }

    function nextCutoff(now){
      var c = new Date(now);
      c.setHours(ch, cm, 0, 0);
      if (now >= c) c = nextDay(c);
      if (skip){ while (isWeekend(c)) c = nextDay(c); }
      return c;
    }
    function deliveryFor(cutoff){
      var d = nextDay(cutoff);
      var left = extra;
      while (left > 0){ d = nextDay(d); if (!skip || !isWeekend(d)) left--; }
      if (skip){ while (isWeekend(d)) d = nextDay(d); }
      return d;
    }
    function two(n){ return n < 10 ? '0' + n : '' + n; }

    function tick(){
      var now = new Date();
      var c = nextCutoff(now);
      var ms = c - now;
      if (ms < 0) ms = 0;
      var s = Math.floor(ms / 1000);
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      elT.textContent = h + (nl ? 'u ' : 'h ') + two(m) + 'm ' + two(sec) + 's';
      var day = deliveryFor(c);
      try { elD.textContent = day.toLocaleDateString(lang, { weekday: 'long' }); }
      catch(e){ elD.textContent = day.toDateString().split(' ')[0]; }
    }
    tick();
    setInterval(tick, 1000);
  }

  function openDrawer(){
    var el = document.querySelector('[data-js-site-cart-sidebar]')
          || document.getElementById('site-cart-sidebar');
    if (typeof window.refreshCart === 'function'){ try { window.refreshCart(); } catch(e){} }
    if (el && typeof el.show === 'function'){ try { el.show(); return true; } catch(e){} }
    var opener = document.querySelector('[data-js-cart-sidebar-trigger], a[href$="/cart"][data-js-cart]');
    if (opener){ try { opener.click(); return true; } catch(e){} }
    return typeof window.refreshCart === 'function';
  }

  function applyCodes(codes){
    var chain = Promise.resolve();
    codes.forEach(function(code){
      chain = chain.then(function(){
        return fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET', credentials: 'same-origin', redirect: 'follow'
        }).catch(function(){});
      });
    });
    return chain;
  }

  /* ---------------- sets & levering ---------------- */
  function init(root){
    if (root.dataset.fvsReady) return;
    root.dataset.fvsReady = '1';

    var timer = root.querySelector('[data-fvs-timer]');
    if (timer) startTimer(timer);

    var T = {
      add    : root.dataset.tAdd    || 'Add to cart',
      adding : root.dataset.tAdding || 'Adding...',
      added  : root.dataset.tAdded  || 'Added',
      save   : root.dataset.tSave   || 'Save',
      etaPre : root.dataset.tEtaPre || '',
      err    : root.dataset.tErr    || 'Something went wrong.',
      pickErr: root.dataset.tPickErr|| 'Pick at least one attachment.',
      prop   : root.dataset.tProp   || 'Delivery',
      after  : destOf(root.dataset.tAfter)
    };
    var EMPTY = 'Deze set heeft nog geen producten. Vul de productlijst in bij de blokinstellingen.';

    var sets   = [].slice.call(root.querySelectorAll('[data-set]'));
    var ships  = [].slice.call(root.querySelectorAll('[data-ship]'));
    var shipBox= root.querySelector('.fvs-list--ship');
    var preNote= shipBox ? shipBox.querySelector('.fvs-note') : null;
    var foot   = root.querySelector('.fvs-foot');
    var elTot  = root.querySelector('[data-total]');
    var elPill = root.querySelector('[data-pill]');
    var elEta  = foot ? foot.querySelector('[data-eta]') : null;
    var elErr  = root.querySelector('[data-err]');
    var btn    = root.querySelector('[data-add]');
    var btnTx  = root.querySelector('[data-add-text]');
    if (!sets.length || !btn) return;

    var sticky = document.querySelector('[data-fvs-sticky="' + root.dataset.fvsId + '"]')
              || (root.parentNode && root.parentNode.querySelector('.fvs-sticky'))
              || document.querySelector('.fvs-sticky');
    var stName  = sticky && sticky.querySelector('[data-s-name]');
    var stPrice = sticky && sticky.querySelector('[data-s-price]');
    var stBtn   = sticky && sticky.querySelector('[data-s-btn]');
    var stBtnTx = stBtn && (stBtn.querySelector('span') || stBtn);

    if (!sets.some(function(s){ return s.getAttribute('aria-checked') === 'true'; })){
      sets[0].setAttribute('aria-checked', 'true');
    }

    function cur(list){
      return list.filter(function(e){ return e.getAttribute('aria-checked') === 'true'; })[0] || list[0];
    }
    function openInc(card){
      if (!card) return;
      var inc = card.querySelector('.fvs-inc');
      if (inc) inc.classList.add('is-open');
    }
    function choose(list, el){
      var changed = el && el.getAttribute('aria-checked') !== 'true';
      list.forEach(function(e){ e.setAttribute('aria-checked', e === el ? 'true' : 'false'); });
      if (changed && list === sets) openInc(el);
      draw();
    }

    sets.forEach(function(card){
      card.addEventListener('click', function(e){
        var open = card.getAttribute('aria-checked') === 'true';
        var head = e.target.closest('.fvs-inc-t');
        if (head && open){
          var inc = head.closest('.fvs-inc');
          if (inc && head === inc.firstElementChild){ inc.classList.toggle('is-open'); return; }
        }
        var box = e.target.closest('[data-pick]');
        if (box && open){
          box.dataset.on = box.dataset.on === 'true' ? 'false' : 'true';
          draw();
          return;
        }
        choose(sets, card);
      });
    });
    ships.forEach(function(e){ e.addEventListener('click', function(){ choose(ships, e); }); });

    function picksOf(card){ return [].slice.call(card.querySelectorAll('[data-pick][data-on="true"]')); }

    function priceOf(card){
      if (!card) return 0;
      if (card.dataset.builder === 'true'){
        var t = parseInt(card.dataset.basePrice || '0', 10);
        picksOf(card).forEach(function(p){ t += parseInt(p.dataset.price || '0', 10); });
        return t;
      }
      return parseInt(card.dataset.price || '0', 10);
    }

    /* Staat de pre-orderkeuze aan?
       Op die lijn gelden de setkortingen niet: de pre-orderfilters staan in de
       catalogus al aan hun halve prijs. Daarom mag het percentage daar over het
       hele bedrag, en gaat de setcode niet mee naar de kassa. Zo is "30%" ook
       echt 30% van wat er op de knop staat. */
    function preShip(sh){ return !!(sh && sh.dataset.preorder === 'true'); }

    function netOf(card){
      if (!card) return 0;
      if (card.dataset.builder === 'true') return priceOf(card);
      var n = card.dataset.net;
      if (n === undefined || n === '') return parseInt(card.dataset.price || '0', 10);
      var v = parseInt(n, 10);
      return isNaN(v) ? parseInt(card.dataset.price || '0', 10) : v;
    }

    function shipOff(base, el, net){
      if (!el) return 0;
      var over = (typeof net === 'number' && net >= 0) ? net : base;
      var m = el.dataset.mode, v = parseFloat(el.dataset.value || '0'), off = 0;
      /* Naar beneden afronden, niet naar het dichtstbijzijnde. Shopify rekent
         een halve cent in het voordeel van de winkel af (30% van € 159,25 is
         € 47,775 en wordt € 47,77), en Math.round maakte er € 47,78 van. Dan
         staat er op de knop een cent minder dan de kassa vraagt. Met floor is
         het omgekeerd: hooguit betaalt iemand een cent minder dan beloofd, en
         daar belt niemand over. */
      if (m === 'percent') off = Math.floor(over * v / 100);
      if (m === 'fixed')   off = Math.round(v * 100);
      return off > base ? base : off;
    }

    function wasOf(card){
      if (!card) return '';
      var w = card.querySelector('.fvs-price .fvs-was');
      return w ? w.textContent.trim() : '';
    }

    /* Kan deze set vooruit besteld worden?
       Gewone set: er moet een pre-orderlijst ingevuld zijn.
       Zelf samenstellen: het basistoestel én elk kopstuk moeten een
       pre-ordervariant hebben. Ontbreekt er één, dan verdwijnt de optie —
       anders geef je korting op iets dat gewoon bij Widem vertrekt. */
    function canPreorder(card){
      if (!card) return false;
      if (card.dataset.builder === 'true'){
        if (!card.dataset.baseVariantPre) return false;
        var picks = [].slice.call(card.querySelectorAll('[data-pick]'));
        if (!picks.length) return false;
        return picks.every(function(p){ return !!p.dataset.variantPre; });
      }
      try { return JSON.parse(card.dataset.itemsPre || '[]').length > 0; }
      catch(e){ return false; }
    }

    function syncShipOptions(set){
      var ok = canPreorder(set);
      var normal = null;
      ships.forEach(function(s){
        if (s.dataset.preorder === 'true'){ s.style.display = ok ? '' : 'none'; }
        else if (!normal){ normal = s; }
      });
      if (preNote) preNote.style.display = ok ? '' : 'none';

      if (!ok && normal){
        var active = cur(ships);
        if (active && active.dataset.preorder === 'true'){
          ships.forEach(function(s){ s.setAttribute('aria-checked', s === normal ? 'true' : 'false'); });
        }
      }
    }

    function draw(){
      var set  = cur(sets);
      syncShipOptions(set);

      var base = priceOf(set);
      var net  = netOf(set);
      var off  = shipOff(base, cur(ships), preShip(cur(ships)) ? base : net);
      var end  = base - off;

      sets.forEach(function(c){
        if (c !== set){
          var inc = c.querySelector('.fvs-inc');
          if (inc) inc.classList.remove('is-open');
        }
      });

      if (set && set.dataset.builder === 'true'){
        var live = set.querySelector('[data-builder-total]');
        if (live) live.textContent = base > 0 ? money(base) : '';
      }

      if (elTot) elTot.textContent = base > 0 ? money(end) : '';
      if (elPill){
        if (off > 0){ elPill.hidden = false; elPill.textContent = T.save + ' ' + money(off); }
        else { elPill.hidden = true; }
      }

      ships.forEach(function(s){
        var cell = s.querySelector('[data-ship-price]');
        if (!cell) return;
        var o = shipOff(base, s, preShip(s) ? base : net);
        cell.innerHTML = o > 0
          ? '<span class="fvs-was">' + money(base) + '</span>' + money(base - o)
          : (base > 0 ? money(base) : '');
      });

      var sh = cur(ships);
      if (elEta) elEta.textContent = sh ? ((T.etaPre ? T.etaPre + ' ' : '') + (sh.dataset.eta || '')) : '';
      if (elErr) elErr.textContent = '';

      if (timer){
        var isPre = sh && sh.dataset.mode && sh.dataset.mode !== 'none';
        timer.style.display = isPre ? 'none' : '';
      }

      if (stName) stName.textContent = set ? (set.dataset.name || '') : '';
      if (stPrice){
        if (base <= 0){ stPrice.textContent = ''; }
        else {
          var wasTxt = off > 0 ? money(base) : wasOf(set);
          stPrice.innerHTML = (wasTxt ? '<s>' + wasTxt + '</s>' : '') + money(end);
        }
      }
    }

    function rawItems(set, sh){
      if (sh && sh.dataset.preorder === 'true'){
        try {
          var pre = JSON.parse(set.dataset.itemsPre || '[]');
          if (pre.length) return pre;
        } catch(e){}
      }
      try { return JSON.parse(set.dataset.items || '[]'); } catch(e){ return []; }
    }

    function itemsFor(set, sh){
      var items = [];
      var pre = !!(sh && sh.dataset.preorder === 'true');

      if (set.dataset.builder === 'true'){
        var chosen = picksOf(set);
        var min = parseInt(set.dataset.minPicks || '0', 10);
        if (min && chosen.length < min) return 'few';

        var baseId = pre ? (set.dataset.baseVariantPre || set.dataset.baseVariant)
                         : set.dataset.baseVariant;
        if (baseId) items.push({ id: parseInt(baseId, 10), quantity: 1 });

        chosen.forEach(function(p){
          var vid = pre ? (p.dataset.variantPre || p.dataset.variant) : p.dataset.variant;
          if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 });
        });
      } else {
        items = rawItems(set, sh);
      }

      items = items.filter(function(it){ return it && it.id; });
      if (!items.length) return 'empty';
      if (sh){
        var props = {};
        props[T.prop] = (sh.dataset.name || '') + ' \u2014 ' + (sh.dataset.eta || '');
        items.forEach(function(it){ it.properties = props; });
      }
      return items;
    }

    function addToCart(trigger, label){
      var set = cur(sets);
      if (!set) return;

      var sh = cur(ships);
      var items = itemsFor(set, sh);
      var link = destOf(set.dataset.link);

      if (items === 'empty' && link){ window.location.href = link; return; }
      if (items === 'few'){ if (elErr) elErr.textContent = T.pickErr; return; }
      if (items === 'empty'){ if (elErr) elErr.textContent = EMPTY; return; }

      var codes = [];
      if (set.dataset.code && !preShip(sh)) codes.push(set.dataset.code.trim());
      if (sh && sh.dataset.code) codes.push(sh.dataset.code.trim());
      codes = codes.filter(Boolean);

      trigger.disabled = true;
      if (label) label.textContent = T.adding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){
        return r.json().then(function(data){
          if (!r.ok) throw new Error(data.description || data.message || 'add failed');
          return data;
        });
      })
      .then(function(){ return applyCodes(codes); })
      .then(function(){
        if (label) label.textContent = T.added;
        if (T.after){ window.location.href = T.after; return; }
        if (!openDrawer()){ window.location.href = '/cart'; return; }
        setTimeout(function(){
          trigger.disabled = false;
          if (label) label.textContent = T.add;
        }, 1200);
      })
      .catch(function(e){
        trigger.disabled = false;
        if (label) label.textContent = T.add;
        if (elErr) elErr.textContent = (e && e.message) ? e.message : T.err;
      });
    }

    btn.addEventListener('click', function(e){ e.preventDefault(); addToCart(btn, btnTx); });
    if (stBtn){
      stBtn.addEventListener('click', function(e){ e.preventDefault(); addToCart(stBtn, stBtnTx); });
    }

    if (sticky && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(btn);
    }

    openInc(cur(sets));
    draw();
  }

  function boot(){ document.querySelectorAll('.fvs-wrap').forEach(init); }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
